<dx-popup
    #changeOwnerEditorPopup
    titleTemplate="title"
    [showTitle]="true"
    width="55%"
    height="85%"
    [resizeEnabled]="true"
    [visible]="visible"
    (onShown)="onEditorShown()"
    (onHidden)="onEditorClose()"
>
    <div *dxTemplate="let data of 'title'">
        <dx-toolbar width="100%">
            <dxi-item location="before">
                <div *dxTemplate>
                    <div class="dx-toolbar-label">Select Owner</div>
                </div>
            </dxi-item>
            <dxi-item location="before">
                <div *dxTemplate>
                    <dx-button stylingMode="text" type="normal" template="buttonTemplate" (onClick)="onHelpIconClick()">
                        <div *dxTemplate="let buttonData of 'buttonTemplate'">
                            <i
                                class="cc-1-5x dx-theme-accent-as-text-color icon-content"
                                [ngClass]="iconHelp"
                                (click)="onHelpIconClick()"
                            ></i>
                        </div>
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button
                        stylingMode="text"
                        type="normal"
                        [icon]="iconClose"
                        (onClick)="onEditorClose()"
                    ></dx-button>
                </div>
            </dxi-item>
        </dx-toolbar>
    </div>
    <div *dxTemplate="let item of 'content'" class="change-owner-editor-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [colCount]="1" [labelLocation]="defaultLabelLocation">
                    <dxi-item>
                        <dxo-label text="Community"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #communitySelector
                                [name]="'Community'"
                                [readOnly]="!!communityId"
                                [gridSource]="communityList"
                                [boxValue]="communityGridBoxValue"
                                [valueExpr]="'communityId'"
                                [displayExpr]="'communityName'"
                                [columnDef]="communityColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: auto }"
                                [placeholder]="'Select Community...'"
                                [showHeaderFilters]="true"
                                (gridSelectionEvent)="onCommunitySelection($event.selectedRow)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Customer Type"></dxo-label>
                        <div *dxTemplate class="radio-group">
                            <dx-radio-group
                                layout="horizontal"
                                valueExpr="key"
                                displayExpr="displayText"
                                [items]="ownersType"
                                [elementAttr]="{ class: 'customer-type-radio-group' }"
                                [(value)]="selectedOwnersType"
                                (onValueChanged)="onSearchClick()"
                            ></dx-radio-group>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Search For"></dxo-label>
                        <div *dxTemplate class="owner-search">
                            <dx-text-box
                                width="80%"
                                stylingMode="outlined"
                                [showClearButton]="true"
                                (onValueChanged)="onSearchTextChange()"
                                (onEnterKey)="onSearchClick()"
                                [(value)]="searchText"
                            ></dx-text-box>
                            <dx-button
                                class="search-button"
                                type="default"
                                [icon]="iconSearch"
                                hint="Search"
                                text="Search"
                                (onClick)="onSearchClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1" class="select-owner-grid">
                <dx-data-grid
                    #changeOwnerEditorGrid
                    width="100%"
                    height="100%"
                    class="cc-vertical-center-cell-data-grid"
                    [dataSource]="changeOwnerData"
                    [showBorders]="true"
                    [showRowLines]="true"
                    [wordWrapEnabled]="true"
                    [columnMinWidth]="30"
                    [columnAutoWidth]="true"
                    [headerFilter]="{ allowSearch: true }"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    columnResizingMode="nextColumn"
                    noDataText="No data to display"
                >
                    <dxi-column alignment="center" cellTemplate="actionTemplate" caption="" [width]="90"></dxi-column>
                    <dxi-column
                        dataField="community"
                        dataType="string"
                        caption="Community"
                        cellTemplate="communityTemplate"
                    ></dxi-column>
                    <dxi-column dataField="owner" dataType="string" caption="Owner"></dxi-column>
                    <dxi-column
                        dataField="accountNumber"
                        dataType="string"
                        caption="Account #"
                        [width]="120"
                        cellTemplate="accountNumberTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="propertyAddress"
                        dataType="string"
                        caption="Property Address"
                        cellTemplate="propertyAddressTemplate"
                    ></dxi-column>
                    <ng-container *ngIf="selectedOwnersType === 'allOwners'">
                        <dxi-column
                            dataField="buyerCloseDate"
                            dataType="date"
                            caption="Effective Date"
                            dateFormat="dateFormat"
                            sortOrder="desc"
                        ></dxi-column>
                        <dxi-column
                            dataField="currentOwner"
                            dataType="boolean"
                            caption="Current Owner"
                            cellTemplate="booleanCellTemplate"
                        ></dxi-column>
                    </ng-container>

                    <div *dxTemplate="let row of 'booleanCellTemplate'">
                        <i *ngIf="row.value" class="cc-check-icon cc-1-5x" [ngClass]="iconCheck"></i>
                        <i *ngIf="!row.value" class="cc-text-required cc-1-5x" [ngClass]="iconClose"></i>
                    </div>

                    <div *dxTemplate="let cell of 'actionTemplate'">
                        <dx-button
                            type="default"
                            text="Select"
                            [icon]="iconCheck"
                            (onClick)="onSelectOwner(cell.data)"
                        ></dx-button>
                    </div>
                    <!-- 
                        NOTE: To maintain consistency throughout the application, we have added context link to community, customerId and PropertyAddress.
                        Agreed with Murthy M.K
                    -->
                    <div *dxTemplate="let record of 'communityTemplate'">
                        <app-property-community-link
                            [communityId]="record.data.communityId"
                            [displayText]="record.data.community"
                        ></app-property-community-link>
                    </div>

                    <div *dxTemplate="let record of 'accountNumberTemplate'">
                        <app-property-community-link
                            [communityId]="record.data.communityId"
                            [customerId]="record.data.accountNumber"
                            [displayText]="record.data.accountNumber"
                        ></app-property-community-link>
                    </div>

                    <div *dxTemplate="let record of 'propertyAddressTemplate'">
                        <app-property-community-link
                            [communityId]="record.data.communityId"
                            [customerId]="record.data.accountNumber"
                            [displayText]="record.data.propertyAddress"
                        ></app-property-community-link>
                    </div>

                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                    <dxo-group-panel [visible]="false"></dxo-group-panel>
                    <dxo-sorting mode="none"></dxo-sorting>
                    <dxo-scrolling mode="standard"></dxo-scrolling>
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <dx-button
                                type="default"
                                text="Close"
                                hint="Close"
                                [icon]="iconClose"
                                (onClick)="onEditorClose()"
                            ></dx-button>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #messageBox></cc-message-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#changeOwnerEditorPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
